import {computed, makeObservable, observable} from "mobx";

export class ProductsCategoryFeature {
    constructor() {
        this._productsCategoryInformation = {
            NombreCategoria: 'PANES PARA CATERING\n',
            ResultadoArticulos: [
                {
                    Id: 1,
                    EsDemo: false,
                    Producto: {
                        Archivos: [
                            {
                                TipoEntidad: 'PRODUCTO',
                                Descripcion: 'Imagen Principal',
                                Url: 'https://via.placeholder.com/150'
                            }
                        ],
                        Nombre: 'MINI FOCACCIA PLAIN'
                    }
                },
                {
                    Id: 2,
                    EsDemo: false,
                    Producto: {
                        Archivos: [
                            {
                                TipoEntidad: 'PRODUCTO',
                                Descripcion: 'Imagen Principal',
                                Url: 'https://via.placeholder.com/150'
                            }
                        ],
                        Nombre: 'MINI PAN ALEMAN BAVARIA'
                    }
                },
                {
                    Id: 3,
                    EsDemo: false,
                    Producto: {
                        Archivos: [
                            {
                                TipoEntidad: 'PRODUCTO',
                                Descripcion: 'Imagen Principal',
                                Url: 'https://via.placeholder.com/150'
                            }
                        ],
                        Nombre: 'BIZCOCHO CUADRADO'
                    }
                }
            ]
        }
        this.loaded = true

        makeObservable(this, {
            _productsCategoryInformation: observable,
            loaded: computed
        });
    }

    get loaded() {
        return this._loaded;
    }

    set loaded(value) {
        this._loaded = value;
    }

    get categoryName() {
        return this._productsCategoryInformation.NombreCategoria;
    }

    get articles() {
        return this._productsCategoryInformation.ResultadoArticulos;
    }

}